module.exports = __webpack_public_path__ + "img/ASDA-logo_UC.a3c89e16.png";